exports = module.exports = require("../../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{@page{margin-top:50px;margin-bottom:50px}}", ""]);

// exports
